// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMpTableDto
 */
export interface IMpTableDto {
    /**
     * 
     * @type {number}
     * @memberof IMpTableDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IMpTableDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IMpTableDto
     */
    identifier?: string;
}

/**
 * Check if a given object implements the IMpTableDto interface.
 */
export function instanceOfIMpTableDto(value: object): value is IMpTableDto {
    return true;
}

export function IMpTableDtoFromJSON(json: any): IMpTableDto {
    return IMpTableDtoFromJSONTyped(json, false);
}

export function IMpTableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMpTableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
    };
}

export function IMpTableDtoToJSON(json: any): IMpTableDto {
    return IMpTableDtoToJSONTyped(json, false);
}

export function IMpTableDtoToJSONTyped(value?: IMpTableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'identifier': value['identifier'],
    };
}

